import { useCurrentFrame, useVideoConfig, interpolate } from 'remotion';

function VSLogo({ size = 80 }) {
  return (
    <svg viewBox="0 0 80 80" style={{ width: size, height: size }}>
      <defs>
        <linearGradient id="vsg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#A059C0"/>
          <stop offset="100%" stopColor="#6B2D8B"/>
        </linearGradient>
      </defs>
      <rect width="80" height="80" rx="8" fill="url(#vsg)"/>
      <path d="M14 20 L36 56 L40 62 L44 56 L66 20 L55 20 L40 47 L25 20Z" fill="white"/>
      <path d="M8 25 L8 55 L14 49 L14 31Z" fill="white" opacity="0.3"/>
    </svg>
  );
}

function SplashScene({ durationInFrames }) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const dur = durationInFrames || fps * 4;

  const fadeIn = interpolate(frame, [0, 20], [0, 1], { extrapolateRight: 'clamp' });
  // Progress bar animates from 0% to 85% over the scene duration
  const progressWidth = interpolate(frame, [10, dur - 10], [0, 85], {
    extrapolateLeft: 'clamp',
    extrapolateRight: 'clamp',
  });

  return (
    <div style={{
      width: '100%', height: '100%', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', position: 'relative',
      background: 'linear-gradient(135deg, #68217A 0%, #4B0082 100%)',
      opacity: fadeIn,
    }}>
      {/* Logo */}
      <div style={{ marginBottom: 32 }}>
        <VSLogo size={120}/>
      </div>

      {/* Title */}
      <h1 style={{ fontSize: 48, fontWeight: 300, color: 'white', margin: 0, letterSpacing: 1 }}>
        Visual Studio 2022
      </h1>
      <p style={{ fontSize: 18, color: 'rgba(255,255,255,0.65)', marginTop: 8, marginBottom: 0 }}>
        Community
      </p>

      {/* Loading bar at bottom */}
      <div style={{
        position: 'absolute', bottom: 60, left: '50%',
        transform: 'translateX(-50%)', width: 360, textAlign: 'center',
      }}>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', marginBottom: 10 }}>
          Loading project...
        </p>
        <div style={{
          width: '100%', height: 3,
          background: 'rgba(255,255,255,0.15)', borderRadius: 2, overflow: 'hidden',
        }}>
          <div style={{
            height: '100%', width: `${progressWidth}%`,
            background: 'rgba(255,255,255,0.8)', borderRadius: 2,
            transition: 'width 0.05s linear',
          }}/>
        </div>
      </div>
    </div>
  );
}

export default function IntroScene({ title, subtitle, durationInFrames, style }) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const dur = durationInFrames || fps * 3;

  const opacity = interpolate(frame, [0, 30, dur - 30, dur], [0, 1, 1, 0], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
  });

  const scale = interpolate(frame, [0, 30], [0.95, 1], { extrapolateRight: 'clamp' });

  if (style === 'splash') {
    return <SplashScene durationInFrames={durationInFrames}/>;
  }

  return (
    <div style={{
      width: '100%', height: '100%', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: '#1e1e1e', color: '#cccccc', opacity,
      transform: `scale(${scale})`,
    }}>
      {/* VS 2022 logo */}
      <VSLogo size={80}/>
      <h1 style={{ fontSize: 42, fontWeight: 600, color: 'white', margin: '30px 0 0' }}>
        {title || 'Visual Studio 2022'}
      </h1>
      {subtitle && (
        <p style={{ fontSize: 20, color: '#999', marginTop: 12 }}>{subtitle}</p>
      )}
    </div>
  );
}
